import { AlertCircle, ArrowRight } from 'lucide-react';

interface OnboardingBannerProps {
  onComplete: () => void;
}

export default function OnboardingBanner({ onComplete }: OnboardingBannerProps) {
  return (
    <div
      onClick={onComplete}
      className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-xl p-4 shadow-lg cursor-pointer hover:from-orange-600 hover:to-orange-700 transition-all"
    >
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
          <AlertCircle className="text-white" size={24} strokeWidth={2.5} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-white font-bold text-base mb-1">Complete Your Health Profile</h3>
          <p className="text-white/95 text-sm leading-snug">
            Discover your biological age and unlock all features
          </p>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onComplete();
          }}
          className="bg-white text-orange-600 px-4 py-2.5 rounded-lg font-bold text-sm hover:bg-orange-50 transition-colors inline-flex items-center gap-2 flex-shrink-0"
        >
          Complete Now
          <ArrowRight size={16} strokeWidth={3} />
        </button>
      </div>
    </div>
  );
}
